module.exports = {
	"library.navbar.sign_up": "S'inscrire",
	"library.navbar.sign_in": "Se connecter",
	"library.navbar.sign_out": "Se déconnecter",
	"library.navbar.help": "Aide",
	"library.navbar.search_for_events": "Rechercher des événements",
	"library.navbar.enter_location": "Saisir votre position",
	"library.navbar.find_events": "Trouver des événements",
	"library.navbar.create_event": "Créer un événement",
	"library.navbar.host_events": "Organiser des événements",
	"library.navbar.dashboard": "Tableau de bord",
	"library.navbar.my_events": "Mes événements",
	"library.navbar.my_tickets": "Mes billets",
	"library.navbar.admin_panel": "Panneau d'administration",
	"library.navbar.profile": "Profil",
	"library.navbar.messages": "Messages",
	"library.navbar.settings": "Paramètres",
	"library.navbar.search_cities": "Rechercher des villes",
	"library.navbar.help_center": "Centre d'aide",
	"library.navbar.cant_find_tickets": "Où sont mes billets ?",
	"library.navbar.contact_organizer": "Contacter l'organisateur de l'événement",
	"library.navbar.can_refund": "Puis-je obtenir un remboursement ?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/fr.json
// module id = 1513
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16